/**
 * Single horizontal inset for platform shells (agency baseline).
 * Use for Header Toolbar, Layout main, and subdomain inner wrappers so
 * nav and body align at the same left/right gutters.
 */
export const AGENCY_SHELL_HORIZONTAL_PX = { xs: 2, sm: 3, md: 4 } as const;

/** AppBar Toolbar minHeight — one definition so the bar looks the same on every shell. */
export const HEADER_TOOLBAR_MIN_HEIGHT = { xs: 56, sm: 58 } as const;

/**
 * Live AppBar height published by Header (ResizeObserver) on documentElement.
 * Prefer this over HEADER_TOOLBAR_MIN_HEIGHT when sizing full-viewport shells
 * (Studio builder, etc.) — real chrome is often taller than the toolbar minHeight.
 */
export const SITE_HEADER_HEIGHT_CSS_VAR = '--apt-site-header-height';

/** Fallback when the Header has not published SITE_HEADER_HEIGHT_CSS_VAR yet. */
export const SITE_HEADER_HEIGHT_FALLBACK_PX = 64;

/** Desktop header primary nav link size (lg+, non-drawer). */
export const HEADER_DESKTOP_NAV_FONT_SIZE = '0.75rem';
